/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum PageStatus {
  PUBLISHED = "PUBLISHED",
  DRAFT = "DRAFT",
  TRASH = "TRASH",
}

export enum RelationType {
  ONE_TO_ONE = "ONE_TO_ONE",
  ONE_TO_MANY = "ONE_TO_MANY",
  MANY_TO_ONE = "MANY_TO_ONE",
  MANY_TO_MANY = "MANY_TO_MANY",
}

export enum EnumFieldTypeRules {
  Required = "required",
  Unique = "unique",
  Min = "min",
  Max = "max",
  Minlength = "minlength",
  Maxlength = "maxlength",
  Pattern = "pattern",
  ForeignKey = "foreignKey",
}

export enum CustomFieldType {
  Image = "image",
  File = "file",
  Content = "content",
  Select = "select",
}

export enum FieldType {
  String = "string",
  Object = "object",
  Array = "array",
  BinData = "binData",
  Undefined = "undefined",
  ObjectId = "objectId",
  Bool = "bool",
  Date = "date",
  Null = "null",
  Regex = "regex",
  Javascript = "javascript",
  Timestamp = "timestamp",
  Number = "number",
  MinKey = "minKey",
  MaxKey = "maxKey",
}

export enum ModuleType {
  TREE = "TREE",
  LIST = "LIST",
  GRAPH = "GRAPH",
  ONE_TO_ONE = "ONE_TO_ONE",
  ONE_TO_MANY = "ONE_TO_MANY",
  MANY_TO_MANY = "MANY_TO_MANY",
  MANY_TO_ONE = "MANY_TO_ONE",
}

export enum EnumUserFormStatus {
  Draft = "draft",
  Published = "published",
}

export enum EnumUserFormType {
  Email = "email",
  VanillaSave = "vanilla_save",
}

export interface IUserForm {
  /**
   * @minLength 3
   * @maxLength 50
   * @example "User"
   */
  name: string;
  description: string;
  module_type?: ModuleType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  /** @default false */
  isDeleted?: boolean;
  form_type: EnumUserFormType;
  email: string;
  kvkk_documents: any[];
  status: EnumUserFormStatus;
  reCaptcha: {
    enabled: boolean;
    secret_key: string;
    site_key: string;
  };
}

export interface FieldTypeRule {
  rule: EnumFieldTypeRules;
  value?: any;
  description?: string;
  error_message?: string;
}

export interface IModuleFieldType {
  column_name?: string;
  type?: FieldType | CustomFieldType;
  rules: FieldTypeRule[];
  default?: string | number | boolean | any[];
  name: string;
  description: string;
  isVisible?: boolean;
  /** @format double */
  sort_index?: number | null;
  format?: string;
  isMeta?: boolean;
  isEditable?: boolean;
  reference?: {
    relation_type: RelationType;
    field_name: string;
    collection_name: string;
  } | null;
  options?: {
    description?: string;
    value?: string | number | boolean;
    label?: string;
  }[];
  tags?: string[];
}

export interface AppError {
  name: string;
  message: string;
  stack?: string;
  /** @format double */
  status: number;
  details?: any;
}

export interface CreateUserFormResponse {
  collection_name: string;
  module_id: string;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickIUserFormNameOrDescriptionOrModuleType {
  /**
   * @minLength 3
   * @maxLength 50
   * @example "User"
   */
  name: string;
  description: string;
  module_type?: ModuleType;
}

export type UserFormRequestParams = PickIUserFormNameOrDescriptionOrModuleType;

export interface CreateUserFormRequest {
  module_options: UserFormRequestParams;
  fields: IModuleFieldType[];
}

export interface IModuleFieldDocument {
  module_id: string;
  module_name: string;
  module_collection_name: string;
  fields: IModuleFieldType[];
}

export type MongooseAnyObject = Record<string, any>;

export type Document = Record<string, any>;

export interface SearchConsoleSettings {
  siteVerification: string;
}

export interface CaptchaSettings {
  siteKey: string;
  secretKey: string;
}

export interface BrandingSettings {
  brandName: string;
  brandDomain: string;
  defaultLogo: string;
  iconLogo: string;
  variant1Logo: string;
  variant2Logo: string;
}

export interface IPageMeta {
  title: string;
  description?: string;
  keywords?: string;
  image?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  ogType?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
}

export interface IPageChild {
  page: string;
  /** @format double */
  sort_order: number;
}

export interface PageDto {
  _id?: string;
  name: string;
  slug: string;
  view?: string;
  context?: any[];
  meta?: IPageMeta;
  locale: string;
  status?: PageStatus;
  tags?: string[];
  /** @format double */
  sort_order?: number;
  children?: IPageChild[];
  forms?: string[];
}

export interface IMainModule {
  /**
   * @minLength 3
   * @maxLength 50
   * @example "User"
   */
  name: string;
  description: string;
  module_type: ModuleType;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format date-time */
  deletedAt: string;
  /** @default false */
  isDeleted?: boolean;
}

export interface CreateModuleResponse {
  collection_name: string;
  module_id: string;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface PickIMainModuleNameOrDescriptionOrModuleType {
  /**
   * @minLength 3
   * @maxLength 50
   * @example "User"
   */
  name: string;
  description: string;
  module_type: ModuleType;
}

export type MainModuleRequestParams =
  PickIMainModuleNameOrDescriptionOrModuleType;

export interface CreateModuleRequest {
  module_options: MainModuleRequestParams;
  fields: IModuleFieldType[];
}

export type MongooseTypesObjectId = string;

export interface IGroupMember {
  module_id: any;
  name: string;
  key: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
          .then((data) => {
            if (r.ok) {
              r.data = data;
            } else {
              r.error = data;
            }
            return r;
          })
          .catch((e) => {
            r.error = e;
            return r;
          });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title API
 * @version 1.0.0
 * @license MIT
 * @baseUrl /
 * @contact
 *
 * API
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * No description
     *
     * @name HealthCheck
     * @request GET:/v1/health-check
     */
    healthCheck: (params: RequestParams = {}) =>
      this.request<MongooseTypesObjectId, any>({
        path: `/v1/health-check`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name Ping
     * @request GET:/v1/ping
     */
    ping: (
      query?: {
        /**
         * @format double
         * @default 1000
         */
        delayed?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseTypesObjectId, any>({
        path: `/v1/ping`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name Version
     * @request GET:/v1/version
     */
    version: (params: RequestParams = {}) =>
      this.request<MongooseTypesObjectId, any>({
        path: `/v1/version`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Form Collection
     * @name GetUserFormCollectionList
     * @request GET:/v1/user-form/{module_id}/collection
     * @deprecated
     */
    getUserFormCollectionList: (
      moduleId: string,
      query?: {
        skip?: any;
        limit?: any;
        module_populate?: string[];
        list_related?: boolean;
        sort?: string;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format double */
          count: number;
          results: MongooseAnyObject[];
        },
        any
      >({
        path: `/v1/user-form/${moduleId}/collection`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Insert an record to User Form Collection
     *
     * @tags User Form Collection
     * @name InsertToUserFormCollection
     * @summary Insert an record to User Form Collection
     * @request POST:/v1/user-form/{module_id}/collection
     */
    insertToUserFormCollection: (
      moduleId: string,
      data: MongooseAnyObject,
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/user-form/${moduleId}/collection`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Form Collection
     * @name GetUserFormCollectionFind
     * @request GET:/v1/user-form/{module_id}/collection/find
     */
    getUserFormCollectionFind: (
      moduleId: string,
      query?: {
        /**
         * If module has tree structure, list related records
         * @default false
         */
        list_related?: boolean;
        /**
         * If module has reference to other sub module, list this reference modules
         * @default false
         */
        list_referenced?: boolean;
        /**
         * If module has reference to other sub module, populate the reference
         * @default []
         */
        module_populate?: string[];
        /**
         * Maximum number of records to return
         * @format double
         * @default 0
         */
        limit?: number;
        /**
         * Number of records to skip
         * @format double
         * @default 0
         */
        skip?: number;
        /**
         * Sort the records by field <br /> <b>Example:</b> field1:asc,field2:desc
         * @default null
         */
        sort?: string;
        /**
         * Search the records by field. <br/>  <b>Usage:</b> field_name:mongodb_operator:desired_value <br/> <b>Example:</b> field1:$eq:value,field2:$ne:value
         * @default null
         */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format double */
          count: number;
          results: MongooseAnyObject[];
        },
        AppError
      >({
        path: `/v1/user-form/${moduleId}/collection/find`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Form Collection
     * @name GetUserFormCollectionPopulate
     * @request GET:/v1/user-form/{module_id}/collection/populate
     */
    getUserFormCollectionPopulate: (
      moduleId: string,
      query?: {
        /** @default [] */
        module_populate?: string[];
        /**
         * @format double
         * @default 0
         */
        limit?: number;
        /**
         * @format double
         * @default 0
         */
        skip?: number;
        /** @default null */
        sort?: string;
        /** @default null */
        search?: string;
        /** @default false */
        record_populate?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/user-form/${moduleId}/collection/populate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Form Collection
     * @name GetUserFormCollectionDetail
     * @request GET:/v1/user-form/{module_id}/collection/{record_id}/detail
     */
    getUserFormCollectionDetail: (
      moduleId: string,
      recordId: string,
      query?: {
        list_related?: boolean;
        module_populate?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/user-form/${moduleId}/collection/${recordId}/detail`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Find records at User Form Collection by Tags
     *
     * @tags User Form Collection
     * @name GetUserFormCollectionRecordTags
     * @summary Find records at User Form Collection by Tags
     * @request GET:/v1/user-form/{module_id}/collection/{module_id}/collection/tags
     */
    getUserFormCollectionRecordTags: (
      moduleId: string,
      query: {
        /** Tags */
        tags: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject[], any>({
        path: `/v1/user-form/${moduleId}/collection/${moduleId}/collection/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an record tags by Record ID
     *
     * @tags User Form Collection
     * @name UpdateUserFormCollectionTags
     * @summary Update an record tags by Record ID
     * @request PUT:/v1/user-form/{module_id}/collection/{record_id}/tags
     */
    updateUserFormCollectionTags: (
      moduleId: string,
      recordId: string,
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, AppError>({
        path: `/v1/user-form/${moduleId}/collection/${recordId}/tags`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update an record by Record ID
     *
     * @tags User Form Collection
     * @name UpdateUserFormCollection
     * @summary Update an record by Record ID
     * @request PUT:/v1/user-form/{module_id}/collection/{record_id}
     */
    updateUserFormCollection: (
      moduleId: string,
      recordId: string,
      data: MongooseAnyObject,
      params: RequestParams = {},
    ) =>
      this.request<Document, AppError>({
        path: `/v1/user-form/${moduleId}/collection/${recordId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an record by Record ID
     *
     * @tags User Form Collection
     * @name DeleteUserFormCollection
     * @summary Delete an record by Record ID
     * @request DELETE:/v1/user-form/{module_id}/collection/{record_id}
     */
    deleteUserFormCollection: (
      moduleId: string,
      recordId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, AppError>({
        path: `/v1/user-form/${moduleId}/collection/${recordId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description User will submit the form data to the collection
     *
     * @tags User Form Action
     * @name SubmitForm
     * @request POST:/v1/user-form/{module_id}/action
     */
    submitForm: (moduleId: string, data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/user-form/${moduleId}/action`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the form data by module ID for rendering the form
     *
     * @tags User Form Action
     * @name GetForm
     * @request GET:/v1/user-form/{module_id}/action
     */
    getForm: (moduleId: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/user-form/${moduleId}/action`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Form Action
     * @name UploadFile
     * @request POST:/v1/user-form/{module_id}/action/upload
     */
    uploadFile: (
      moduleId: string,
      query?: {
        target_column_name?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/user-form/${moduleId}/action/upload`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetSiteSettings
     * @request GET:/v1/site-settings
     */
    getSiteSettings: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/site-settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCacheList
     * @request GET:/v1/site-settings/cache-list
     */
    getCacheList: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/site-settings/cache-list`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ClearCache
     * @request POST:/v1/site-settings/flush-cache
     */
    clearCache: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/site-settings/flush-cache`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name ClearCacheByKey
     * @request POST:/v1/site-settings/clear-cache
     */
    clearCacheByKey: (
      data: {
        items: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/clear-cache`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AddToWhitelist
     * @request POST:/v1/site-settings/add-to-whitelist
     */
    addToWhitelist: (
      data: {
        items: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/add-to-whitelist`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetWhitelistedRoutes
     * @request GET:/v1/site-settings/whitelisted-routes
     */
    getWhitelistedRoutes: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/v1/site-settings/whitelisted-routes`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name RemoveFromWhitelist
     * @request POST:/v1/site-settings/remove-from-whitelist
     */
    removeFromWhitelist: (
      data: {
        route: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/remove-from-whitelist`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetSeoSettings
     * @request GET:/v1/site-settings/seo
     */
    getSeoSettings: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/site-settings/seo`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateSearchConsoleSettings
     * @request PUT:/v1/site-settings/seo/update-search-console-settings
     */
    updateSearchConsoleSettings: (
      data: SearchConsoleSettings,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/seo/update-search-console-settings`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name AddSitemapItem
     * @request PUT:/v1/site-settings/seo/add-sitemap-item
     */
    addSitemapItem: (
      data: {
        /** @format double */
        priority?: number;
        changeFrequency?: string;
        /** @format date-time */
        lastModified?: string;
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/seo/add-sitemap-item`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteSitemapItem
     * @request DELETE:/v1/site-settings/seo/delete-sitemap-item
     */
    deleteSitemapItem: (
      query: {
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/seo/delete-sitemap-item`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name GetGeneralSettings
     * @request GET:/v1/site-settings/general
     */
    getGeneralSettings: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/site-settings/general`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCaptchaSettings
     * @request PUT:/v1/site-settings/general/update-captcha-settings
     */
    updateCaptchaSettings: (
      data: CaptchaSettings,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/general/update-captcha-settings`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateBrandingSettings
     * @request PUT:/v1/site-settings/general/update-branding-settings
     */
    updateBrandingSettings: (
      data: BrandingSettings,
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/site-settings/general/update-branding-settings`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPages
     * @request GET:/v1/pages
     */
    getPages: (
      query?: {
        locale?: string;
        /** @format double */
        sort?: number;
        tags?: string[];
        related?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/pages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetLocales
     * @request GET:/v1/pages/locales
     */
    getLocales: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/locales`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPage
     * @request GET:/v1/pages/page
     */
    getPage: (
      query: {
        slug: string;
        locale: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/pages/page`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPageById
     * @request GET:/v1/pages/{id}
     */
    getPageById: (id: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name DeletePage
     * @request DELETE:/v1/pages/{id}
     */
    deletePage: (id: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPageLocales
     * @request GET:/v1/pages/{id}/locales
     */
    getPageLocales: (id: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/locales`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name CreatePageLocales
     * @request POST:/v1/pages/{id}/locales
     */
    createPageLocales: (id: string, data?: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/locales`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name CreatePage
     * @request POST:/v1/pages/create
     */
    createPage: (data: PageDto, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name CreateLocale
     * @request POST:/v1/pages/locales/new
     */
    createLocale: (data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/locales/new`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name CreateChild
     * @request POST:/v1/pages/{id}/childs
     */
    createChild: (id: string, data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/childs`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name CopyPage
     * @request POST:/v1/pages/{id}/copy
     */
    copyPage: (id: string, data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/copy`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdatePage
     * @request PUT:/v1/pages/update
     */
    updatePage: (data: PageDto, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdateChildSort
     * @request PUT:/v1/pages/{id}/childs/sort
     */
    updateChildSort: (id: string, data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/childs/sort`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name UpdatePageForms
     * @request PUT:/v1/pages/{id}/forms
     */
    updatePageForms: (id: string, data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/forms`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name GetPageForms
     * @request GET:/v1/pages/{id}/forms
     */
    getPageForms: (id: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/forms`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name Render
     * @request GET:/v1/page/*
     */
    render: (
      query?: {
        slug?: string;
        response?: string;
        related?: boolean;
        cms_parent_page?: boolean;
        cms_parent_children?: boolean;
        cms_children_addons?: boolean;
        cms_list_page_forms?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v1/page/*`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pages
     * @name DeleteChild
     * @request DELETE:/v1/pages/{id}/childs/{childId}
     */
    deleteChild: (id: string, childId: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/pages/${id}/childs/${childId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Main Module Collection
     * @name GetMainModuleCollectionList
     * @request GET:/v1/main-module/{module_id}/collection
     * @deprecated
     */
    getMainModuleCollectionList: (
      moduleId: string,
      query?: {
        skip?: any;
        limit?: any;
        module_populate?: string[];
        list_related?: boolean;
        /** @format double */
        max_depth?: number;
        sort?: string;
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format double */
          count: number;
          results: MongooseAnyObject[];
        },
        any
      >({
        path: `/v1/main-module/${moduleId}/collection`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Insert an record to Main Module Collection
     *
     * @tags Main Module Collection
     * @name InsertToMainModuleCollection
     * @summary Insert an record to Main Module Collection
     * @request POST:/v1/main-module/{module_id}/collection
     */
    insertToMainModuleCollection: (
      moduleId: string,
      data: MongooseAnyObject,
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/main-module/${moduleId}/collection`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Main Module Collection
     * @name GetMainModuleCollectionFind
     * @request GET:/v1/main-module/{module_id}/collection/find
     */
    getMainModuleCollectionFind: (
      moduleId: string,
      query?: {
        /**
         * If module has tree structure, list related records
         * @default false
         */
        list_related?: boolean;
        /**
         * @format double
         * @default 0
         */
        max_depth?: number;
        /**
         * If module has reference to other sub module, list this reference modules
         * @default false
         */
        list_referenced?: boolean;
        /**
         * If module has reference to other sub module, populate the reference
         * @default []
         */
        module_populate?: string[];
        /**
         * Maximum number of records to return
         * @format double
         * @default 0
         */
        limit?: number;
        /**
         * Number of records to skip
         * @format double
         * @default 0
         */
        skip?: number;
        /**
         * Sort the records by field <br /> <b>Example:</b> field1:asc,field2:desc
         * @default null
         */
        sort?: string;
        /**
         * Search the records by field. <br/>  <b>Usage:</b> field_name:mongodb_operator:desired_value <br/> <b>Example:</b> field1:$eq:value,field2:$ne:value
         * @default null
         */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format double */
          count: number;
          results: MongooseAnyObject[];
        },
        AppError
      >({
        path: `/v1/main-module/${moduleId}/collection/find`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Main Module Collection
     * @name GetMainModuleCollectionPopulate
     * @request GET:/v1/main-module/{module_id}/collection/populate
     * @deprecated
     */
    getMainModuleCollectionPopulate: (
      moduleId: string,
      query?: {
        /** @default [] */
        module_populate?: string[];
        /**
         * @format double
         * @default 0
         */
        limit?: number;
        /**
         * @format double
         * @default 0
         */
        skip?: number;
        /** @default null */
        sort?: string;
        /** @default null */
        search?: string;
        /** @default false */
        record_populate?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/main-module/${moduleId}/collection/populate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Main Module Collection
     * @name GetMainModuleCollectionDetail
     * @request GET:/v1/main-module/{module_id}/collection/{record_id}/detail
     */
    getMainModuleCollectionDetail: (
      moduleId: string,
      recordId: string,
      query?: {
        list_related?: boolean;
        populate?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/main-module/${moduleId}/collection/${recordId}/detail`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Find records at Main Module Collection by Tags
     *
     * @tags Main Module Collection
     * @name GetMainModuleCollectionRecordTags
     * @summary Find records at Main Module Collection by Tags
     * @request GET:/v1/main-module/{module_id}/collection/{module_id}/collection/tags
     */
    getMainModuleCollectionRecordTags: (
      moduleId: string,
      query: {
        /** Tags */
        tags: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject[], any>({
        path: `/v1/main-module/${moduleId}/collection/${moduleId}/collection/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Update an record tags by Record ID
     *
     * @tags Main Module Collection
     * @name UpdateMainModuleCollectionTags
     * @summary Update an record tags by Record ID
     * @request PUT:/v1/main-module/{module_id}/collection/{record_id}/tags
     */
    updateMainModuleCollectionTags: (
      moduleId: string,
      recordId: string,
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, AppError>({
        path: `/v1/main-module/${moduleId}/collection/${recordId}/tags`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update an record by Record ID
     *
     * @tags Main Module Collection
     * @name UpdateMainModuleCollection
     * @summary Update an record by Record ID
     * @request PUT:/v1/main-module/{module_id}/collection/{record_id}
     */
    updateMainModuleCollection: (
      moduleId: string,
      recordId: string,
      data: MongooseAnyObject,
      params: RequestParams = {},
    ) =>
      this.request<Document, AppError>({
        path: `/v1/main-module/${moduleId}/collection/${recordId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an record by Record ID
     *
     * @tags Main Module Collection
     * @name DeleteMainModuleCollection
     * @summary Delete an record by Record ID
     * @request DELETE:/v1/main-module/{module_id}/collection/{record_id}
     */
    deleteMainModuleCollection: (
      moduleId: string,
      recordId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, AppError>({
        path: `/v1/main-module/${moduleId}/collection/${recordId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Collection
     * @name GetMainModuleCollectionFind2
     * @request GET:/v1/gp/{group_id}/{gp_key}/find
     * @originalName getMainModuleCollectionFind
     * @duplicate
     */
    getMainModuleCollectionFind2: (
      groupId: string,
      gpKey: string,
      query?: {
        /**
         * If module has tree structure, list related records
         * @default false
         */
        list_related?: boolean;
        /**
         * @format double
         * @default 0
         */
        max_depth?: number;
        /**
         * If module has reference to other sub module, list this reference modules
         * @default false
         */
        list_referenced?: boolean;
        /**
         * If module has reference to other sub module, populate the reference
         * @default []
         */
        module_populate?: string[];
        /**
         * Maximum number of records to return
         * @format double
         * @default 0
         */
        limit?: number;
        /**
         * Number of records to skip
         * @format double
         * @default 0
         */
        skip?: number;
        /**
         * Sort the records by field <br /> <b>Example:</b> field1:asc,field2:desc
         * @default null
         */
        sort?: string;
        /**
         * Search the records by field. <br/>  <b>Usage:</b> field_name:mongodb_operator:desired_value <br/> <b>Example:</b> field1:$eq:value,field2:$ne:value
         * @default null
         */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format double */
          count: number;
          results: MongooseAnyObject[];
        },
        AppError
      >({
        path: `/v1/gp/${groupId}/${gpKey}/find`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Collection
     * @name GetMainModuleCollectionPopulate2
     * @request GET:/v1/gp/{group_id}/{gp_key}/populate
     * @originalName getMainModuleCollectionPopulate
     * @duplicate
     */
    getMainModuleCollectionPopulate2: (
      groupId: string,
      gpKey: string,
      query?: {
        /** @default [] */
        module_populate?: string[];
        /**
         * @format double
         * @default 0
         */
        limit?: number;
        /**
         * @format double
         * @default 0
         */
        skip?: number;
        /** @default null */
        sort?: string;
        /** @default null */
        search?: string;
        /** @default false */
        record_populate?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/gp/${groupId}/${gpKey}/populate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Collection
     * @name GetMainModuleCollectionDetail2
     * @request GET:/v1/gp/{group_id}/{gp_key}/{record_id}/detail
     * @originalName getMainModuleCollectionDetail
     * @duplicate
     */
    getMainModuleCollectionDetail2: (
      groupId: string,
      gpKey: string,
      recordId: string,
      query?: {
        list_related?: boolean;
        module_populate?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject, AppError>({
        path: `/v1/gp/${groupId}/${gpKey}/${recordId}/detail`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Find records at Groups Collection by Tags
     *
     * @tags Groups Collection
     * @name GetMainModuleCollectionRecordTags2
     * @summary Find records at Groups Collection by Tags
     * @request GET:/v1/gp/{group_id}/{gp_key}/collection/tags
     * @originalName getMainModuleCollectionRecordTags
     * @duplicate
     */
    getMainModuleCollectionRecordTags2: (
      groupId: string,
      gpKey: string,
      query: {
        /** Tags */
        tags: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<MongooseAnyObject[], any>({
        path: `/v1/gp/${groupId}/${gpKey}/collection/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Management
     * @name GetGroups
     * @request GET:/v1/gp
     */
    getGroups: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/gp`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Management
     * @name CreateGroup
     * @request POST:/v1/gp
     */
    createGroup: (
      data: {
        roles: string[];
        members: IGroupMember[];
        description: string;
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, AppError>({
        path: `/v1/gp`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Management
     * @name GetGroup
     * @request GET:/v1/gp/{group_id}
     */
    getGroup: (groupId: string, params: RequestParams = {}) =>
      this.request<any, AppError>({
        path: `/v1/gp/${groupId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Management
     * @name UpdateGroup
     * @request PUT:/v1/gp/{group_id}
     */
    updateGroup: (
      groupId: string,
      data: {
        roles: string[];
        members: IGroupMember[];
        description: string;
        name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, AppError>({
        path: `/v1/gp/${groupId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Groups Management
     * @name DeleteGroup
     * @request DELETE:/v1/gp/{group_id}
     */
    deleteGroup: (groupId: string, params: RequestParams = {}) =>
      this.request<boolean, AppError>({
        path: `/v1/gp/${groupId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
}